module.exports = ".status-hide {\r\n    display: none;\r\n}"